module.exports = __webpack_public_path__ + "media/svg-new/monster-1-af0761a4.svg";